import { isDecimalNeeded } from 'shared/utils/strUtil';
import { DisplayMetricTypes } from 'usage/constants/costAndUsageConstants';
import { adjustK8SResourceTypeValue } from 'usage/containers/CostAndUsageExplorer/helpers/stateMachine/baseCostUsageDataState';
import InfoPopover from 'shared/components/andtComponents/InfoPopover';
import React from 'react';

export const POD_DETAILS_TABLE_COLUMNS_WIDTHS = [
  { columnName: 'parameter', width: 200 },
  { columnName: 'requests', width: 100 },
  { columnName: 'usage', width: 100 },
  { columnName: 'usageWaste', width: 100 },
  { columnName: 'cost', width: 100 },
  { columnName: 'costWaste', width: 100 },
  { columnName: 'totalCost', width: 100 },
];

export const getCellDisplayValue = (
  row: {
    cost: string;
    costWaste: string;
    parameter: string;
  },
  param: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  numStrAbriviaionByDisplayMetric: any,
) => {
  if (!row[param]) {
    row[param] = 0;
  }
  const value = row[param] / 1000;
  if (row.parameter === 'cpu') {
    return `${value.toFixed(isDecimalNeeded(value, 3) ? 3 : 0)} Cores`;
  }

  return numStrAbriviaionByDisplayMetric(row[param], row[param], DisplayMetricTypes.BYTES, false, { decimal: 3 });
};

export const POD_DETAILS_TABLE_COLUMNS_EXTENSIONS = [
  { columnName: 'cost', align: 'center' },
  { columnName: 'costWaste', align: 'center' },
  { columnName: 'usage', align: 'center' },
  { columnName: 'usageWaste', align: 'center' },
  { columnName: 'totalCost', align: 'center' },
];

// eslint-disable-next-line react-refresh/only-export-components
const StorageNotAvailable = () => (
  <InfoPopover isSimple>Storage usage data is not available in the current K8s metrics</InfoPopover>
);

export const POD_DETAILS_TABLE_COLUMNS: Array<{
  name: string;
  title: string;
  formatNumValue?: boolean;
  getCellValue?: (row: {
    cost: string;
    usage: string;
    usageWaste: string;
    requests: string;
    costWaste: string;
    parameter: string;
    totalCost?: string;
  }) => undefined | number | string | React.ReactElement;
}> = [
  {
    name: 'parameter',
    title: 'Parameter',
    getCellValue: (row) => adjustK8SResourceTypeValue(row.parameter),
  },
  {
    name: 'requests',
    title: 'Requests',
    formatNumValue: true,
    getCellValue: (row) => (row.parameter === 'storage' ? <StorageNotAvailable /> : undefined),
  },
  {
    name: 'usage',
    title: 'Usage',
    formatNumValue: true,
    getCellValue: (row) => (row.parameter === 'storage' ? <StorageNotAvailable /> : undefined),
  },
  {
    name: 'usageWaste',
    title: 'Usage Waste',
    formatNumValue: true,
    getCellValue: (row) => (row.parameter === 'storage' ? <StorageNotAvailable /> : undefined),
  },
  {
    name: 'cost',
    title: 'Usage Cost',
  },
  { name: 'costWaste', title: 'Usage Waste Cost' },
  {
    name: 'totalCost',
    title: 'Total Cost',
    getCellValue: (row) =>
      row.totalCost !== undefined ? parseFloat(row.totalCost) : parseFloat(row.cost) + parseFloat(row.costWaste),
  },
];
